export const getTransportationTypeName = (category, t) => {
  if (!category) return "";
  const key = category.key ?? category;
  const fallback = category.name ?? key;
  return t(key, { ns: "vehicle", defaultValue: fallback });
};
